module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [(_vm.designerList) ? _c('div', [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "设计师名称：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入设计师名称",
      "maxlength": "15"
    },
    model: {
      value: (_vm.designerName),
      callback: function($$v) {
        _vm.designerName = $$v
      },
      expression: "designerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "cityname",
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "所属城市：",
      "label-width": "120px"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangeOne
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "所属店铺：",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.dianpu),
      callback: function($$v) {
        _vm.dianpu = $$v
      },
      expression: "dianpu"
    }
  }, _vm._l((_vm.dianpuArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "状态：",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.zhuangtai),
      callback: function($$v) {
        _vm.zhuangtai = $$v
      },
      expression: "zhuangtai"
    }
  }, _vm._l((_vm.cStatusarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.fininfo()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("设计师")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showadd()
      }
    }
  }, [_vm._v("新 增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.goodList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "align": "center",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "设计师",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.designername
          }
        }, [_vm._v(_vm._s(scope.row.designername))])]
      }
    }], null, false, 3250065860)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CPhone",
      "label": "所属城市",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.provincename + '-' + scope.row.cityname
          }
        }, [_vm._v(_vm._s(scope.row.provincename) + " - " + _vm._s(scope.row.cityname))])]
      }
    }], null, false, 675300167)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Phone",
      "align": "center",
      "label": "联系电话"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.phone
          }
        }, [_vm._v(_vm._s(scope.row.phone))])]
      }
    }], null, false, 2420192938)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属店铺",
      "prop": "ShopName",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.shopname
          }
        }, [_vm._v(_vm._s(scope.row.shopname))])]
      }
    }], null, false, 2926722308)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DayCounts",
      "label": "当天预约",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.reservation_today_count))]
      }
    }], null, false, 3845372097)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "WeekCounts",
      "label": "本周预约",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.reservation_week_count))]
      }
    }], null, false, 2911686714)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "MonthCounts",
      "label": "本月预约",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.reservation_month_count))]
      }
    }], null, false, 518504118)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "YearCounts",
      "label": "本年预约",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.reservation_year_count))]
      }
    }], null, false, 2706978697)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AllCounts",
      "label": "全部预约",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.reservation_all_count))]
      }
    }], null, false, 1970430087)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OnlineStatusName",
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.statusname))]
      }
    }], null, false, 278999182)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.showadd(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n            ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.over(scope)
            }
          }
        }, [_c('i', {
          class: scope.row.status == 1 ? 'el-icon-download' : 'el-icon-upload2'
        }), _vm._v("\r\n              " + _vm._s(scope.row.status == 1 ? '下架' : '上架') + "\r\n            ")])]
      }
    }], null, false, 3006433377)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _c('div', {
    staticClass: "main_container"
  }, [_c('h2', {
    staticClass: "shopTitle"
  }, [_vm._v("设计师基本信息")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设计师名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入设计师名称",
      "maxlength": "10"
    },
    model: {
      value: (_vm.sjsName),
      callback: function($$v) {
        _vm.sjsName = $$v
      },
      expression: "sjsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": ""
    },
    on: {
      "change": _vm.handleChangeTwo
    },
    model: {
      value: (_vm.selectedOptions3),
      callback: function($$v) {
        _vm.selectedOptions3 = $$v
      },
      expression: "selectedOptions3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "从业年限："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入从业年限",
      "maxlength": "2",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    model: {
      value: (_vm.WorkTime),
      callback: function($$v) {
        _vm.WorkTime = $$v
      },
      expression: "WorkTime"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("年")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设计收费："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "最低价位",
      "maxlength": "8",
      "disabled": _vm.checked1,
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "blur": _vm.despricebulr
    },
    model: {
      value: (_vm.MinDesignPrice),
      callback: function($$v) {
        _vm.MinDesignPrice = $$v
      },
      expression: "MinDesignPrice"
    }
  }), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "最高价位",
      "maxlength": "8",
      "disabled": _vm.checked1,
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "blur": _vm.despricebulr
    },
    model: {
      value: (_vm.MaxDesignPrice),
      callback: function($$v) {
        _vm.MaxDesignPrice = $$v
      },
      expression: "MaxDesignPrice"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("元/平米")]), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "change": function($event) {
        return _vm.mianyi()
      }
    },
    model: {
      value: (_vm.checked1),
      callback: function($$v) {
        _vm.checked1 = $$v
      },
      expression: "checked1"
    }
  }, [_vm._v("面议")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "专长风格："
    }
  }, [_c('span', {
    staticClass: "choice",
    on: {
      "click": _vm.choiestyle
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.styletrue),
      expression: "styletrue"
    }]
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.styleNamearr), function(item, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "擅长空间："
    }
  }, [_c('span', {
    staticClass: "choice",
    on: {
      "click": _vm.choosekong
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowbrand),
      expression: "isshowbrand"
    }],
    staticStyle: {
      "width": "60%"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.homenamearr), function(item, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "extend",
    attrs: {
      "label": "个人简介(选填)："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "maxlength": "500",
      "show-word-limit": "",
      "placeholder": "请输入个人简介："
    },
    model: {
      value: (_vm.IntroduceSelf),
      callback: function($$v) {
        _vm.IntroduceSelf = $$v
      },
      expression: "IntroduceSelf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "extend",
    attrs: {
      "label": "设计理念(选填)："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "maxlength": "20",
      "show-word-limit": "",
      "placeholder": "请输入设计理念："
    },
    model: {
      value: (_vm.DesignerIdea),
      callback: function($$v) {
        _vm.DesignerIdea = $$v
      },
      expression: "DesignerIdea"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "extend",
    attrs: {
      "label": "荣誉奖项(选填)："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "maxlength": "500",
      "show-word-limit": "",
      "placeholder": "请输入荣誉奖项"
    },
    model: {
      value: (_vm.PersonalHonor),
      callback: function($$v) {
        _vm.PersonalHonor = $$v
      },
      expression: "PersonalHonor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约量："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入预约量",
      "maxlength": "6",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    model: {
      value: (_vm.ReservationCount),
      callback: function($$v) {
        _vm.ReservationCount = $$v
      },
      expression: "ReservationCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "签单量："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入签单量",
      "maxlength": "6",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    model: {
      value: (_vm.OrderCount),
      callback: function($$v) {
        _vm.OrderCount = $$v
      },
      expression: "OrderCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设计师电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入设计师电话",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设计师头像："
    }
  }, [(_vm.LogoUrl) ? _c('div', {
    staticStyle: {
      "width": "88px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-8px",
      "z-index": "1",
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        _vm.LogoUrl = ''
      }
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.LogoUrl,
      "preview-src-list": [_vm.LogoUrl]
    },
    on: {
      "click": _vm.handleClickItem
    }
  })], 1) : _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "accept": ".png, .jpg",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1比1 ，支持的图片格式，jpg、png。")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图片："
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgShopArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "6px",
        "top": "-8px",
        "cursor": "pointer",
        "width": "20px",
        "z-index": "1"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "display": "inline-block",
        "margin-right": "15px"
      },
      attrs: {
        "src": item,
        "fit": "cover"
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgShopArr.length < 5),
      expression: "imgShopArr.length<5"
    }],
    staticClass: "upload",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadShopIntroduction
    }
  }, [(_vm.zstpUrl) ? _c('img', {
    staticClass: "avatar-zstp",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.zstpUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus icon-zstp"
  })])], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1200*675，支持的图片格式：jpg、png。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频（选填）："
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.designerList = true
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.typeId == 1 ? '专长风格' : '承接范围',
      "visible": _vm.dialogVisible2,
      "width": "900px",
      "before-close": _vm.handleClose2
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia"
  }, [_c('div', {
    staticClass: "searchLeft"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.typeId == 1 ? '请选择专长风格' : '请选择承接范围'))])]), _vm._v(" "), _c('div', {
    staticClass: "searchRight"
  }, [_c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.brandList), function(item, index) {
    return _c('p', {
      key: index,
      ref: "styleName",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosedBrand(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMore) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goReturn2()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.sureChoose2()
      }
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "擅长空间",
      "visible": _vm.centerDialogVisible,
      "width": "900px",
      "before-close": _vm.handleClose2
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia"
  }, [_c('div', {
    staticClass: "searchLeft"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v("请选择擅长空间")])]), _vm._v(" "), _c('div', {
    staticClass: "searchRight"
  }, [_c('div', {
    staticClass: "searchTop"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("家装")])]), _vm._v(" "), _c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.homearr), function(item, index) {
    return _c('p', {
      key: index,
      ref: "home",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosehome(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMore) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "searchTop",
    staticStyle: {
      "border-top": "1px solid #f6f6f6"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("公装")])]), _vm._v(" "), _c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.workarr), function(item, index) {
    return _c('p', {
      key: index,
      ref: "work",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosework(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMore) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.wangong,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.wangong = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_vm._v(_vm._s(_vm.IsOnline == 1 ? '确定下架此条信息' : '确定上架此条信息'))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makeover()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.wangong = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择装修公司",
      "visible": _vm.dialogVisibleadd,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "装修公司："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择装修公司"
    },
    model: {
      value: (_vm.DesId),
      callback: function($$v) {
        _vm.DesId = $$v
      },
      expression: "DesId"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.shopid,
      attrs: {
        "label": item.shopname,
        "value": item.shopid
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisibleadd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": "",
      "width": "1000",
      "height": "1000"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": "",
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确 认")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a2d2874!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/listdes.vue
// module id = 1695
// module chunks = 3